import React from 'react';
import { Table } from 'reactstrap';

export const TsuOceanicModal = {
  title: 'Oceanic Tsunami',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>Yes / No</b>
      </div>
      <br />
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">Yes</th>
            <td>indicates the tsunami originated in an ocean body</td>
          </tr>
          <tr>
            <th scope="row">No</th>
            <td>disturbance or tsunami waves originated in an inland river/lake</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
